import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { User } from './../models/user';
import { Species } from '../models/species';
import { Animal, AnimalVaccineValence } from './../models/animal';
import { VaccineValence, VaccineLabel } from './../models/vaccine';
import { StorageService } from './storage.service'
import { AlertController } from '@ionic/angular';
import { NetworkService } from './network.service';
import { AnimalService } from './animal.service';
import { UserService } from './user.service';
import { IndexedDbService } from './indexed-db.service';
import { blobToBase64 } from '../utils'
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class VaccineService {
  valences: VaccineValence[] = [];
  labels: VaccineLabel[] = [];

  constructor(
      private http: HttpClient,
      public storageService: StorageService,
      public networkService: NetworkService,
      public animalService: AnimalService,
      private translate: TranslateService,
      private userService: UserService,
      public indexedDbService: IndexedDbService,
      public alertController: AlertController) { }


  dbGetLabelsOfSpecies(speciesId: number): Promise<VaccineLabel[]> {
    return new Promise(async (resolve) => {
      if (this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        this.http.get<any[]>(environment.API_URL + 'vaccine/ws_private/' + speciesId + '/GetLabelsOfSpecies/', {headers : headers}).subscribe(async (response: { [key: string]: any }) => {
          this.storageService.set('offline_vaccine_labels_response_' + speciesId, response);
          for(var dataValence of response['valences']) {
            var valence = this.valences.find(b => b.id == dataValence['valence']['id'])
            if(!valence){
              valence = new VaccineValence()
              valence.id = dataValence['valence']['id']
              valence.name = dataValence['valence']['name']
              valence.fullName = dataValence['valence']['fullName']
              valence.description = dataValence['valence']['description']
              valence.isDisplayOnHome = dataValence['valence']['isDisplayOnHome']
              valence.species = this.animalService.speciess.find(a => a.id == dataValence['valence']['speciesId']);
              this.valences.push(valence);
            }

            for(let a of dataValence['labels']) {
              var label = this.labels.find(b => b.id == a['id'])
              if(!label){
                label = new VaccineLabel()
                this.labels.push(label);
              }
              label.id = a['id']
              label.name = a['name']
              if(!label.valences.find(b => b.id == valence?.id))
              label.valences.push(valence)
            }
          }

          resolve(this.labels.filter(a => a.valences.find(b => b.species?.id == speciesId)));
        },
        async () => {
          const memCache = this.labels.filter(a => a.valences.find(b => b.species?.id == speciesId));
          if (memCache.length > 0) { resolve(memCache); }
          else {
            const cached = await this.storageService.get('offline_vaccine_labels_response_' + speciesId);
            if (cached) { resolve(this.labels.filter(a => a.valences.find(b => b.species?.id == speciesId))); }
            else { resolve([]); }
          }
        })
      } else {
        const memCache = this.labels.filter(a => a.valences.find(b => b.species?.id == speciesId));
        if (memCache.length > 0) { resolve(memCache); }
        else {
          const cached = await this.storageService.get('offline_vaccine_labels_response_' + speciesId);
          if (cached) { resolve(this.labels.filter(a => a.valences.find(b => b.species?.id == speciesId))); }
          else { resolve([]); }
        }
      }
    });
  }

  sendRequestNewLabel(animal: Animal, label: string, date: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        let formData: { [key: string]: any } = {};
        formData["animalId"] = animal.id;
        formData["label"] = label;
        formData["date"] = date;

        this.http.post<any[]>(environment.API_URL + 'vaccine/ws_private/SendRequestNewLabel/', formData, {headers : headers}).subscribe({
          next: (response: { [key: string]: any }) => {
            resolve(true);
          },
          error: async (error) => {
          }
        });
      } else {
        resolve(false)
      }
    });
  }
  
}
